module.exports = __webpack_public_path__ + "img/P150T_weapon_120.bc756fce.png";